import React from 'react';
import _get from 'lodash.get';
import {
    Button,
    Checkbox,
    ExpansionPanel,
    ExpansionPanelDetails,
    ExpansionPanelSummary,
    FormControlLabel,
    Grid,
    Chip,
    Paper,
    Typography,
    withStyles,
} from 'material-ui';
import TextField from 'material-ui/TextField/TextField';
import moment from 'moment';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import { FormControl, FormGroup } from 'material-ui/Form/index';
import classNames from 'classnames';
import HotelCategoryRender from '../Reservation/HotelCategoryRender';
import ClearIcon from 'material-ui-icons/Clear';
import SearchIcon from 'material-ui-icons/Search';
import { getAvailability } from '../../services/availabilityService';
import { translate } from 'react-i18next';
import { getUserInformation } from '../Login/loginService';

String.prototype.capitalize = function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

const MaterialIcon = ({ icon, classes }) => {

    //Este workarround se hace porque no normalizamos la base de datos.
    icon = String(icon || '');
    icon = icon.capitalize();
    icon = icon.replace(/(_(\w{1}))/ig, function () { return arguments[2].toUpperCase(); });
    let iconName = icon ? icon.replace(/Icon$/, '') : icon;
    try {
        let resolved = require(`material-ui-icons/${iconName}`).default;
        if (!resolved) {
            //throw Error(`Could not find material-ui-icons/${iconName}`)
            return <Chip label={icon} />;
        } else {
            return React.createElement(resolved, { className: classes.expandIcon, style: { verticalAlign: 'bottom' } });
        }
    } catch (e) {
        return <Chip label={icon} />;
    }
};

const styles = theme => ({
    root: {
        flexGrow: 1
    },
    heading: {
        color: theme.palette.primary.main,
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    panelSummary: {
        background: '#FFFFFF',
        paddingRight: 0,
        height: '50px',
        minHeight: '50px',
    },
    filterHeading: {
        background: '#424242',
        color: '#FFFFFF',
        textAlign: 'center',
    },
    checkboxCount: {
        color: '#919191',
        textAlign: 'right',
        marginRight: '8px',
        fontWeight: 300,
        fontSize: '0.875rem'
    },
    rightIcon: {
        marginLeft: theme.spacing.unit,
        width: '1rem',
        height: '1rem',
    },
    clearFiltersButton: {
        color: 'white',
        fontSize: '0.625rem',
        fontWeight: '400',
        backgroundColor: theme.palette.background.filtersButton,
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        },
    },
    searchByNameButton: {
        color: 'white',
        fontSize: '0.625rem',
        fontWeight: '400',
        backgroundColor: theme.palette.background.filtersButton,
        width: '16px'
    },
    expanded: {
        marginTop: '5px',
        marginBottom: '5px',
    },
    expandIcon: {
        color: theme.palette.primary.main
    },
    title: {
        color: theme.palette.primary.main,
        fontWeight: 'bold',
    }
});

function renderCategories(category) {
    return <HotelCategoryRender category={category} />;
}

function renderBreaks(breaks) {
    const { code, description } = breaks;
    return <span style={{ display: 'flex', alignItems: 'center' }}>
        <img style={{ width: '15px', marginRight: '10px' }} src={'assets/icons/breaks-' + code + '.svg'} />
        <span>{description}</span>
    </span>;
}

function toTitleCase(text, categoryType) {
    //const titleCased = S(text.toLowerCase()).titleCase().s;
    return <span style={{ fontWeight: 300 }}>{text}</span>;
}
function renderCategoryTitle(filter, object, lang, props) {
    const { t, classes } = props;
    if (filter === 'categories') {
        return renderCategories(object);
    }
    let desc = object['description_' + lang] || object.description;

    if (filter === 'facilities') {
        return <span style={{ fontWeight: 300 }}>
            <MaterialIcon icon={object.code} classes={classes} /> {desc}
        </span>;
    }

    if (filter === 'cancellationFees') {
        return toTitleCase(t(desc), filter)
    }

    return toTitleCase(desc, filter);
}

/**
 *  Main sidebar with filters to apply to availability results
 *
 */
class Filters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hotelNameText: '',
        };
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        if (this.props.filtersData && this.props.filtersData.hotelName
            && this.props.filtersData.hotelName[0]) {
            this.setState({ hotelNameText: this.props.filtersData.hotelName[0].code });
        }
    }

    handleFilterChange(index, filterName, value) {
        this.props.onFilterChange(index, filterName, value);
        this.forceUpdate();
    }

    handleOnRequestChange = () => {
        this.props.onFilterChange(0, 'onrequest', true);
        return;
    }

    handleAvailableChange = (value) => {
        this.props.onFilterChange(0, 'available', true);
        return;
    }

    handlePrepaymentChange = (value) => {
        this.props.onFilterChange(0, 'cardPrepaid', true);
        return;
    }

    handleRecommendedHotelsChange = () => {
        this.props.onFilterChange(0, 'recommendedHotels', true);
        return;
    }

    handleFavoritesHotelsChange = () => {
        this.props.onFilterChange(0, 'favoritesHotels', true);
        return;
    }

    clearFilters = () => {
        this.props.onClearFilters();
    }

    async getAvailability() {

        try {
            let data = JSON.parse(localStorage.getItem('searchContentState'));

            /*
            HistogramOption : {
                "type": "mealPlan",
                "jsonpath": "@mealPlan",
                "code": "SA",
                "label": "SA",
                "description": "SA",
                "checked": false,
                "count": 16
            }
            */

            let opts = {
                checkInDate: moment(data.arrival).format('DD/MM/YYYY'),
                nights: data.nights,
                rooms: data.rooms,
                allowRQ: this.props.filtersData.onrequest.code
            };

            if (data.isEroski && data.isEroskiSelected) {
                opts = Object.assign(opts, { destination: this.state.exclusiveDestinationSelected });
            } else if (Array.isArray(data.selectedSuggestion.code)) {
                opts = Object.assign(opts, {
                    countryCode: data.selectedSuggestion.code[0],
                    stateCode: data.selectedSuggestion.code[1],
                    townCode: data.selectedSuggestion.code[2],
                });
            } else { // Es un hotel!
                opts = Object.assign(opts, {
                    hotels: [data.selectedSuggestion.code]
                });
            }

            let result = await getAvailability(opts);
            return result;
        } catch (error) {
            console.error(error);
        }
    }

    renderFilterOptions(props, title, filter, t) {
        const { filtersData, classes } = props;
        let filterCheckbox = filtersData[filter];

        const { user_detail } = getUserInformation();

        return (
            <ExpansionPanel defaultExpanded={true} className={classes.expanded}>
                <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
                    className={classNames(classes.panelSummary, 'ExpansionPanel')}>
                    <Typography className={classNames(classes.heading, classes.title)}>
                        {title}
                    </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails className="FiltersFormControl">
                    <FormControl fullWidth>
                        <FormGroup row>
                            {filterCheckbox
                                ? filterCheckbox.map((checkbox, index) => (
                                    <Grid
                                        container
                                        direction='row'
                                        alignItems='center'
                                        style={{
                                            border: '0px solid red',
                                            marginBottom: 2
                                        }}
                                        key={index}>
                                        <Grid
                                            item
                                            className={'checkbox-' + filter}
                                            xs={11}>
                                            <FormControlLabel
                                                style={{ marginRight: 5 }}
                                                control={
                                                    <Checkbox
                                                        style={{ width: 28, height: 28 }}
                                                        checked={checkbox.checked}
                                                        onChange={(event) => {
                                                            //event.preventDefault();
                                                            //checkbox.checked = !checkbox.checked;
                                                            this.handleFilterChange(index, filter, event);
                                                        }}
                                                        value={checkbox.code}
                                                    />
                                                }
                                                label={
                                                    filter !== 'breaks'
                                                        ? renderCategoryTitle(filter, checkbox, String(user_detail.language).toLowerCase(), this.props)
                                                        : renderBreaks(checkbox)
                                                }
                                            />
                                        </Grid>
                                        <Grid item xs={1} className={'checkbox-' + filter}>
                                            <div className={classes.checkboxCount}>
                                                {checkbox.count}
                                            </div>
                                        </Grid>
                                    </Grid>
                                ))
                                : ''}
                        </FormGroup>
                    </FormControl>
                </ExpansionPanelDetails>
            </ExpansionPanel>
        );
    }

    onKeyDown = (event) => {
        if (event.keyCode === 13) {
            this.setState({ hotelNameText: event.target.value }, this.searchByName);
        }
    };

    onChange = (event) => {
        this.setState({ hotelNameText: event.target.value });
    }

    clearHotelNameSearch = () => {
        this.setState({ hotelNameText: '' }, this.searchByName);
    }

    searchByName = () => {
        this.props.onFilterChange(0, 'hotelName', this.state.hotelNameText);
    }

    isArrayEmpty = (props) => {
        return _get(this.props, props, []).length === 0;
    }

    render() {
        const { classes, isFiltered, t, filtersData } = this.props;
        //Estos 2 filtros reciben 1 tratamiento especial
        const hotelFilter = filtersData ? filtersData.hotelName[0] : null;
        const onrequestFilter = filtersData && filtersData.onrequest ? filtersData.onrequest[0] : null;
        const availableFilter = filtersData && filtersData.available ? filtersData.available[0] : null;
        const prepaidCardFilter = filtersData && filtersData.cardPrepaid ? filtersData.cardPrepaid[0] : null;
        const onRecommendedHotelFilter = filtersData && filtersData.recommendedHotels ? filtersData.recommendedHotels[0] : null;
        const onFavoritesHotelFilter = filtersData && filtersData.favoritesHotels ? filtersData.favoritesHotels[0] : null;
        return (
            <div className={classes.root}>
                <Paper position="static" className={classes.filterHeading} style={{ backgroundColor: '#6B7176', height: '41px', justifyContent: 'center' }}>
                    <Typography variant="subheading" align="center" color="inherit" style={{ paddingTop: '8px' }}>
                        {t('INVOICES.FILTER_RESULTS_BUTTON')}
                    </Typography>
                </Paper>
                {isFiltered ?
                    <Paper position="static" className={classes.filterHeading}>
                        <Button
                            onClick={this.clearFilters}
                            className={classes.clearFiltersButton}
                            color="primary"
                            fullWidth>
                            {t('COMMON.CLEAR_FILTERS')}
                            <ClearIcon className={classes.rightIcon} />
                        </Button>
                    </Paper>
                    : ''}

                {/* ON_REQUEST - AVAILABLE - PREPAID */}
                {(onrequestFilter || availableFilter || prepaidCardFilter) ?
                    <ExpansionPanel defaultExpanded={true} className={classes.expanded}>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
                            className={classNames(classes.panelSummary, 'ExpansionPanel')}>
                            <Typography className={classNames(classes.heading, classes.title)}>
                                {t('INVOICES.RESERVATION')}
                            </Typography>
                        </ExpansionPanelSummary>

                        <ExpansionPanelDetails className="FiltersFormControl">
                            <FormGroup row>
                                {onrequestFilter ?
                                    <div style={{ width: '100%' }}>
                                        <Grid
                                            container
                                            direction='row'
                                            alignItems='center'
                                            style={{
                                                border: '0px solid red',
                                                marginBottom: 2
                                            }} >
                                            <Grid
                                                item
                                                xs={10}>

                                                <FormControlLabel
                                                    style={{ marginRight: 5 }}
                                                    control={
                                                        <Checkbox
                                                            checked={onrequestFilter.code}
                                                            onChange={this.handleOnRequestChange}
                                                            style={{ width: 28, height: 28 }}
                                                            value="onrequest"
                                                            color="primary"
                                                        />
                                                    }
                                                    label={<span style={{ fontWeight: 300 }}>{t('COMMON.ON_REQUEST')}</span>}
                                                />
                                            </Grid>
                                            <Grid item xs={1}>
                                                <div className={classes.checkboxCount}>
                                                    {onrequestFilter.count}
                                                </div>
                                            </Grid>
                                        </Grid>

                                    </div>

                                    : null}


                                {availableFilter ?
                                    <div style={{ width: '100%' }}>
                                        <Grid container
                                            direction='row'
                                            alignItems='center'
                                            style={{
                                                border: '0px solid red',
                                                marginBottom: 2
                                            }} >
                                            <Grid item xs={10}>
                                                <FormControlLabel
                                                    style={{ marginRight: 5 }}
                                                    control={
                                                        <Checkbox
                                                            checked={availableFilter.code}
                                                            onChange={this.handleAvailableChange}
                                                            style={{ width: 28, height: 28 }}
                                                            value="available"
                                                            color="primary"
                                                        />
                                                    }
                                                    label={<span style={{ fontWeight: 300 }}>{t('COMMON.AVAILABLE')}</span>}
                                                />
                                            </Grid>
                                            <Grid item xs={1}>
                                                <div className={classes.checkboxCount}>
                                                    {availableFilter.count}
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </div>
                                    : null}


                                {prepaidCardFilter ?
                                    <div style={{ width: '100%' }}>
                                        <Grid container
                                            direction='row'
                                            alignItems='center'
                                            style={{
                                                border: '0px solid red',
                                                marginBottom: 2
                                            }} >
                                            <Grid item xs={10}>
                                                <FormControlLabel
                                                    style={{ marginRight: 5 }}
                                                    control={
                                                        <Checkbox
                                                            checked={prepaidCardFilter.code}
                                                            onChange={this.handlePrepaymentChange}
                                                            style={{ width: 28, height: 28 }}
                                                            value="cardPrepaid"
                                                            color="primary"
                                                        />
                                                    }
                                                    label={<span style={{ fontWeight: 300 }}>{t('COMMON.PREPAYMENT_BY_CARD')}</span>}
                                                />
                                            </Grid>
                                            <Grid item xs={1}>
                                                <div className={classes.checkboxCount}>
                                                    {prepaidCardFilter.count}
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </div>
                                    : null}

                            </FormGroup>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    : ''}

                {/* RECOMMENDED_HOTELS */}
                {onRecommendedHotelFilter ?
                    <ExpansionPanel defaultExpanded={true} className={classes.expanded}>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
                            className={classNames(classes.panelSummary, 'ExpansionPanel')}>
                            <Typography className={classNames(classes.heading, classes.title)}>
                                {t('INVOICES.FILTER_RECOMMENDED_HOTEL')}
                            </Typography>
                        </ExpansionPanelSummary>

                        <ExpansionPanelDetails className="FiltersFormControl">
                            <FormGroup row style={{ width: '100%' }}>
                                <div style={{ width: '100%' }}>
                                    <Grid container
                                        direction='row'
                                        alignItems='center'
                                        style={{
                                            border: '0px solid red',
                                            marginBottom: 2
                                        }}>
                                        <Grid item xs={10}>
                                            <FormControlLabel
                                                style={{ marginRight: 5 }}
                                                control={
                                                    <Checkbox
                                                        checked={onRecommendedHotelFilter.code}
                                                        onChange={this.handleRecommendedHotelsChange}
                                                        style={{ width: 28, height: 28 }}
                                                        value="recommendedHotels"
                                                        color="primary"
                                                    />
                                                }
                                                label={<span style={{ fontWeight: 300 }}>{t('INVOICES.FILTER_RECOMMENDED_HOTEL')}</span>}
                                            />
                                        </Grid>
                                        <Grid item xs={1}>
                                            <div className={classes.checkboxCount}>
                                                {onRecommendedHotelFilter.count}
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>


                            </FormGroup>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    : ''}

                    {/* FAVORITES_HOTELS */}
                {onFavoritesHotelFilter ?
                    <ExpansionPanel defaultExpanded={true} className={classes.expanded}>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
                            className={classNames(classes.panelSummary, 'ExpansionPanel')}>
                            <Typography className={classNames(classes.heading, classes.title)}>
                                {t('INVOICES.FILTER_FAVORITES_HOTELS')}
                            </Typography>
                        </ExpansionPanelSummary>

                        <ExpansionPanelDetails className="FiltersFormControl">
                            <FormGroup row style={{ width: '100%' }}>
                                <div style={{ width: '100%' }}>
                                    <Grid container
                                        direction='row'
                                        alignItems='center'
                                        style={{
                                            border: '0px solid red',
                                            marginBottom: 2
                                        }}>
                                        <Grid item xs={10}>
                                            <FormControlLabel
                                                style={{ marginRight: 5 }}
                                                control={
                                                    <Checkbox
                                                        checked={onFavoritesHotelFilter.code}
                                                        onChange={this.handleFavoritesHotelsChange}
                                                        style={{ width: 28, height: 28 }}
                                                        value="favoritesHotels"
                                                        color="primary"
                                                    />
                                                }
                                                label={<span style={{ fontWeight: 300 }}>{t('INVOICES.FILTER_FAVORITES_HOTELS')}</span>}
                                            />
                                        </Grid>
                                        <Grid item xs={1}>
                                            <div className={classes.checkboxCount}>
                                                {onFavoritesHotelFilter.count}
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>


                            </FormGroup>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    : ''}

                {/* HOTEL NAME */}
                {hotelFilter ?
                    <ExpansionPanel defaultExpanded={true} className={classes.expanded + ' cmsNameFilter'}>
                        <ExpansionPanelSummary
                            expandIcon={<ExpandMoreIcon className={classes.expandIcon} />}
                            className={classNames(classes.panelSummary, 'ExpansionPanel')}>
                            <Typography className={classNames(classes.heading, classes.title)}>
                                {t('INVOICES.HOTEL_NAME')}
                            </Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="FiltersFormControl">
                            <Grid container direction='row'>
                                <Grid item xs={10}>
                                    <TextField
                                        fullWidth
                                        autoFocus={false}
                                        placeholder={t('INVOICES.HOTEL_NAME')}
                                        onChange={this.onChange}
                                        onKeyDown={this.onKeyDown}
                                        value={this.state.hotelNameText}
                                    />
                                </Grid>
                                <Grid item xs={1}>
                                    <Button
                                        onClick={this.searchByName}
                                        color="primary"
                                        style={{
                                            minWidth: '24px',
                                            height: '24px',
                                            padding: '5px 1px 5px 1px'
                                        }}
                                    >
                                        <SearchIcon
                                            style={{
                                                minWidth: '24px',
                                                height: '24px',
                                            }}
                                        />
                                    </Button>
                                </Grid>
                            </Grid>
                        </ExpansionPanelDetails>
                        <Button
                            onClick={this.clearHotelNameSearch}
                            color="primary"
                            style={{
                                width: '95%',
                                marginLeft: '5px'
                            }}
                        >
                            <u>{t('INVOICES.CLEAR_HOTEL_NAME')}</u>
                        </Button>
                    </ExpansionPanel>
                    : ''}

                {/* PRICES */}
                { !this.isArrayEmpty('filtersData.priceRanges') ? this.renderFilterOptions(this.props, t('INVOICES.PRICE'), 'priceRanges') : ''}

                {/* CATEGORIES */}
                { !this.isArrayEmpty('filtersData.categories') ? this.renderFilterOptions(this.props, t('INVOICES.CATEGORIES'), 'categories') : ''}

                {/* TOWNS */}
                { !this.isArrayEmpty('filtersData.towns') ? this.renderFilterOptions(this.props, t('INVOICES.TOWNS'), 'towns') : ''}

                {/* MEALPLANS */}
                { !this.isArrayEmpty('filtersData.mealPlans') ? this.renderFilterOptions(this.props, t('INVOICES.MEAL_PLAN'), 'mealPlans') : ''}

                {/* OFFERS */}
                { !this.isArrayEmpty('filtersData.offers') ? this.renderFilterOptions(this.props, t('COMMON.OFFERS'), 'offers') : ''}

                {/* CANCELLATION FEES */}
                { !this.isArrayEmpty('filtersData.cancellationFees') ? this.renderFilterOptions(this.props, t('COMMON.CANCELLATION_FEES'), 'cancellationFees') : ''}

                { /* BREAKS */}
                { !this.isArrayEmpty('filtersData.breaks') ? this.renderFilterOptions(this.props, t('COMMON.BREAKS'), 'breaks') : ''}

                {/* PERFIL ESTABLEC */}
                { !this.isArrayEmpty('filtersData.accomodations') ? this.renderFilterOptions(this.props, t('COMMON.ACCOMM_TYPE'), 'accomodations', t) : ''}

                {/* FACILITIES */}
                { !this.isArrayEmpty('filtersData.facilities') ? this.renderFilterOptions(this.props, t('INVOICES.SERVICIES'), 'facilities', t) : ''}

            </div>
        );
    }
}

export default translate('translations')(withStyles(styles)(Filters));



// WEBPACK FOOTER //
// ./src/components/Results/Filters.js